import { jsx as f, Fragment as e } from "react/jsx-runtime";
import { Global as r } from "@emotion/react";
const o = {
  FoundersGrotesk: "Founders Grotesk",
  FoundersGroteskMono: "Founders Grotesk Mono"
}, U = {
  "300-italic": {
    path: "https://assets.whalar.com/fonts/founders-grotesk-light-italic.woff2",
    css: `
      @font-face {
          font-family: "${o.FoundersGrotesk}";
          font-style: italic;
          font-weight: 300;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-light-italic.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  },
  300: {
    path: "https://assets.whalar.com/fonts/founders-grotesk-light.woff2",
    css: `
      @font-face {
          font-family: "${o.FoundersGrotesk}";
          font-style: normal;
          font-weight: 300;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-light.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  },
  "400-italic": {
    path: "https://assets.whalar.com/fonts/founders-grotesk-regular-italic.woff2",
    css: `
      @font-face {
          font-family: "${o.FoundersGrotesk}";
          font-style: italic;
          font-weight: 400;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-regular-italic.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  },
  400: {
    path: "https://assets.whalar.com/fonts/founders-grotesk-regular.woff2",
    css: `
      @font-face {
          font-family: "${o.FoundersGrotesk}";
          font-style: normal;
          font-weight: 400;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-regular.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  },
  "500-italic": {
    path: "https://assets.whalar.com/fonts/founders-grotesk-medium-italic.woff2",
    css: `
      @font-face {
          font-family: "${o.FoundersGrotesk}";
          font-style: italic;
          font-weight: 500;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-medium-italic.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  },
  500: {
    path: "https://assets.whalar.com/fonts/founders-grotesk-medium.woff2",
    css: `
      @font-face {
          font-family: "${o.FoundersGrotesk}";
          font-style: normal;
          font-weight: 500;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-medium.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  },
  "600-italic": {
    path: "https://assets.whalar.com/fonts/founders-grotesk-semibold-italic.woff2",
    css: `
      @font-face {
          font-family: "${o.FoundersGrotesk}";
          font-style: italic;
          font-weight: 600;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-semibold-italic.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  },
  600: {
    path: "https://assets.whalar.com/fonts/founders-grotesk-semibold.woff2",
    css: `
      @font-face {
          font-family: "${o.FoundersGrotesk}";
          font-style: normal;
          font-weight: 600;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-semibold.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  },
  "700-italic": {
    path: "https://assets.whalar.com/fonts/founders-grotesk-bold-italic.woff2",
    css: `
      @font-face {
          font-family: "${o.FoundersGrotesk}";
          font-style: italic;
          font-weight: 700;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-bold-italic.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  },
  700: {
    path: "https://assets.whalar.com/fonts/founders-grotesk-bold.woff2",
    css: `
      @font-face {
          font-family: "${o.FoundersGrotesk}";
          font-style: normal;
          font-weight: 700;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-bold.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  },
  "mono-300": {
    path: "https://assets.whalar.com/fonts/founders-grotesk-mono-light.woff2",
    css: `
      @font-face {
          font-family: ${o.FoundersGroteskMono};
          font-style: normal;
          font-weight: 300;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-mono-light.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  },
  "mono-400": {
    path: "https://assets.whalar.com/fonts/founders-grotesk-mono-regular.woff2",
    css: `
      @font-face {
          font-family: ${o.FoundersGroteskMono};
          font-style: normal;
          font-weight: 400;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-mono-regular.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  },
  "mono-500": {
    path: "https://assets.whalar.com/fonts/founders-grotesk-mono-medium.woff2",
    css: `
      @font-face {
          font-family: ${o.FoundersGroteskMono};
          font-style: normal;
          font-weight: 500;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-mono-medium.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  },
  "mono-600": {
    path: "https://assets.whalar.com/fonts/founders-grotesk-mono-semibold.woff2",
    css: `
      @font-face {
          font-family: "${o.FoundersGrotesk}";
          font-style: normal;
          font-weight: 600;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-mono-semibold.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  },
  "mono-700": {
    path: "https://assets.whalar.com/fonts/founders-grotesk-mono-bold.woff2",
    css: `
      @font-face {
          font-family: ${o.FoundersGroteskMono};
          font-style: normal;
          font-weight: 700;
          src: url(https://assets.whalar.com/fonts/founders-grotesk-mono-bold.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
              U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
              U+FEFF, U+FFFD;
      }`
  }
}, F = ({ fonts: t = ["400", "500", "mono-400"] }) => /* @__PURE__ */ f(r, { styles: t.map((s) => U[s].css).join(`
`) }), l = ({
  fonts: t = ["400", "500", "mono-400"]
}) => /* @__PURE__ */ f(e, { children: t.map((s) => /* @__PURE__ */ f("link", { rel: "preload", as: "font", href: U[s].path, crossOrigin: "" })) });
export {
  o as FONTS,
  F as ThemeFont,
  l as ThemeFontPreload
};
//# sourceMappingURL=fonts.es.js.map
